import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, mergeMap} from "rxjs/operators";
import {PrsAuthFacadeService} from "../../services/prs-auth-facade-service/prs-auth-facade.service";

@Injectable()
export class ModulTozsamosciInterceptor implements HttpInterceptor {

  constructor(
    private prsAuthFacadeService: PrsAuthFacadeService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.prsAuthFacadeService.isAuthenticated() && request.url.indexOf('auth/realms') === -1) {
      return this.prsAuthFacadeService.getAccessTokenObs()
        .pipe(
          map(token => this.cloneRequest(request, token)),
          mergeMap(request => next.handle(request))
        )
    }
    return next.handle(request);
  }

  private cloneRequest(request: HttpRequest<unknown>, accessToken: string ): HttpRequest<unknown> {
    return request.clone({
      setHeaders: { Authorization: `Bearer ${accessToken}` }
    });
  }

}
